<template>
  <div class="user-rate">
    <div class="page-header">
      <h3 class="page-header_title">Top users</h3>
      <span class="page-header_description">These users are the best!</span>
      <router-link class="btn btn-blue route-back" to="/profile">
        <i class="fas fa-angle-left"></i> Profile
      </router-link>
    </div>
    <div class="content">
      <div class="flex-container flex-item table-header">
        <span>Place</span><span>User</span><span>Points</span>
      </div>
      <ol v-if="userRates.length > 0">
        <li
          :class="['flex-item flex-container top-style-list', (userRate.currentUser ? 'user-rate-current': '')]"
          v-for="(userRate, $index) in this.userRates" :key="$index">
          <span>{{getTopNumberString($index+1)}}</span>
          <span>{{userRate.userName}}</span>
          <span>{{userRate.rate}}</span>
        </li>
        <li class="user-rate_divider" v-if="!isUserInTop">
          <span>...</span>
        </li>
        <li class='flex-item flex-container top-style-list' v-if="!isUserInTop">
          <span>{{userData.place}}st</span>
          <span>{{userData.firstName}} {{userData.lastName}}</span>
          <span>{{userData.rate}}</span>
        </li>
      </ol>
      <p class="user-rate_empty" v-else>Here will be user rates</p>
    </div>
  </div>
</template>

<script>
    import {USER_RATES_REQUEST} from "../store/actions/userData";
    import {GET_USER_DATA} from "../store/actions/auth";

    export default {
        name: "TopUsers",
        data() {
            return {
                userRates: [],
                isUserInTop: null,
                userData: {
                    place: 0,
                    firstName: '',
                    lastName: '',
                    rate: 0
                }
            }
        },
        created() {
            this.$store.dispatch(USER_RATES_REQUEST).then(data => {
                this.userRates = data;
                this.isUserInTop = data.some(x => x.currentUser);
            });

            this.$store.dispatch(GET_USER_DATA, localStorage.currentUserId);
            this.userData = this.$store.getters.getCurrentUserData;
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCurrentUserData,
                (userData) => {
                    this.userData = userData;
                },
            );
        },
        methods: {
            nextToProfile() {
                this.$router.push('/profile');
            },
            getTopNumberString(placeNumber) {
                switch (placeNumber) {
                    case 1:
                        return '1st';
                    case 2:
                        return '2nd';
                    case 3:
                        return '3rd';
                    default:
                        return `${placeNumber}th`
                }
            }
        }
    }
</script>

<style scoped>

</style>
